import { useCallback, useState } from "react";
import { useAppContext } from "../../providers/ProviderAppContainer";
import { Dialog } from "primereact/dialog";
import TabHeader from "../common/TabHeader";
import { FloatLabel } from "primereact/floatlabel";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";

export default function DialogAddPolicy({ visible, setPolicies, closeDialog }) {
    const { requestAPI, showToast } = useAppContext();

    const [policy, setPolicy] = useState({});
    const [loading, setLoading] = useState();

    const addPolicy = useCallback(() => {
        requestAPI({
            requestPath: `policies`,
            requestMethod: "POST",
            requestPostBody: policy,
            setLoading: setLoading,
            onRequestFailure: () => showToast({ severity: "error", summary: "Failed", detail: "Failed To Add Policy !", life: 2000 }),
            onResponseReceieved: ({ error, ...policy }, responseCode) => {
                if (policy && responseCode === 201) {
                    showToast({ severity: "success", summary: "Added", detail: "Policy Added", life: 1000 });
                    setPolicies((prev) => [policy, ...prev]);
                    setPolicy({});
                    closeDialog();
                } else showToast({ severity: "error", summary: "Failed", detail: error || "Failed To Add Policy !", life: 2000 });
            },
        });
    }, [closeDialog, policy, requestAPI, setPolicies, showToast]);

    return (
        <Dialog pt={{ content: { className: "overflow-y-auto" } }} header={`Add New Policy`} visible={visible} className="w-11" onHide={closeDialog}>
            <TabHeader className="pt-3" title="Add New Policy" highlights={["New Policy Can Be Added"]} />

            <FloatLabel className="mt-5">
                <InputText
                    value={policy?.title || ""}
                    id="title"
                    className="w-full"
                    onChange={(e) => setPolicy((prev) => ({ ...prev, title: e.target.value }))}
                    disabled={loading}
                />
                <label htmlFor="title">Title</label>
            </FloatLabel>

            <FloatLabel className="mt-5">
                <InputTextarea
                    value={policy?.description || ""}
                    id="description"
                    rows={5}
                    cols={30}
                    className="w-full"
                    onChange={(e) => setPolicy((prev) => ({ ...prev, description: e.target.value }))}
                    disabled={loading}
                />
                <label htmlFor="description">Description</label>
            </FloatLabel>

            <Button className="mt-3" label="Add Policy" severity="warning" loading={loading} onClick={addPolicy} />
        </Dialog>
    );
}
